const routes = [
  {
    index: true,
    label: 'Faith Johnson',
    path: '/',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Publications and Projects',
    path: '/publications',
  },
  {
    label: 'Presentations',
    path: '/presentations',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
